import React, { useContext, useState } from 'react';
import { Col, Form, Input, Radio, Row } from 'antd';
import PropTypes from 'prop-types';
import tokens from '../../../../../../../../utils/tokens';
import AloneCol from '../../../../../../../../components/common/AloneCol';
import { EnrollmentFormContext } from '../../../../../../../../providers/EnrollmentFormContextProvider';
import InputNumber from '../../../../../../../../components/form/inputs/InputNumber';
import InputRut from '../../../../../../../../components/form/inputs/InputRut';
import InputGeo from '../../../../../../../../components/common/inputs/InputGeo';
import form from '../../../../../../../../utils/form';
import FileSelect from '../../../../../../../../components/form/upload/SingleUpload';
import IdentificationType from '../../../../../../../../enums/identificationType';

const MandataryForm = ({ field }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const [selectedRut, setSelectedRut] = useState(false);

  const { fieldKey, name, ...restField } = field;

  const toggleRutCheck = () => {
    setSelectedRut(true);
  };

  const togglePassportCheck = () => {
    setSelectedRut(false);
  };

  return (
    <>
      <Row gutter={[tokens.forms.horizontalGutterInPx]}>
        <Col span={24}>
          <Form.Item
            label="Nombre o Razón Social del empleador"
            name={[name, 'employerName']}
            fieldKey={[fieldKey, 'employerName']}
            rules={[{ required: true }]}
            shouldUpdate
            {...restField}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name={[name, 'identificationType']}
            fieldKey={[name, 'identificationType']}
            {...restField}
          >
            <Radio.Group defaultValue={1}>
              <Radio value={IdentificationType.RUT} onChange={toggleRutCheck}>
                Rut
              </Radio>
              <Radio value={IdentificationType.PASAPORTE} onChange={togglePassportCheck}>
                Pasaporte
              </Radio>
              <Radio value={IdentificationType.OTRO} onChange={togglePassportCheck}>
                Otro
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <AloneCol lg={12} xs={24}>
          <Form.Item
            label="Nº de Identificación"
            name={[name, 'identification']}
            fieldKey={[fieldKey, 'identification']}
            rules={[
              {
                required: true,
                message: 'Dato requerido',
              },
            ]}
            {...restField}
          >
            {selectedRut ? <InputRut /> : <Input />}
          </Form.Item>
        </AloneCol>
        <Col span={24}>
          <Form.Item
            label="Nombres"
            name={[name, 'name']}
            rules={[
              {
                required: true,
                message: 'Nombre es requerido',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col lg={12} xs={24}>
          <Form.Item
            label="Apellido paterno"
            name={[name, 'firstSurname']}
            rules={[
              {
                required: true,
                message: 'Dato requerido',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col lg={12} xs={24}>
          <Form.Item label="Apellido materno" name={[name, 'secondSurname']}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Row gutter={[tokens.forms.horizontalGutterInPx]}>
            <Col lg={12} xs={24}>
              <Form.Item
                label="E-mail"
                name={[name, 'email']}
                rules={[
                  {
                    required: true,
                    type: 'email',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col lg={24} xs={24}>
          <InputGeo
            form={enrollmentForm}
            countryName={[name, 'address', 'country']}
            regionName={[name, 'address', 'region']}
            cityName={[name, 'address', 'city']}
          />
        </Col>
        <Col span={12}>
          <Form.Item
            name={[name, 'address', 'streetName']}
            label="Calle/Avenida"
            rules={[{ required: true, message: 'Dato requerido' }]}
          >
            <Input maxLength={32} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={[name, 'address', 'streetNumber']}
            label="Número"
            rules={[{ required: true, message: 'Dato requerido' }]}
          >
            <InputNumber hideArrows maxLength={8} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name={[name, 'address', 'houseNumber']} label="Departamento / Oficina">
            <Input maxLength={10} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[tokens.forms.horizontalGutterInPx]}>
        <Col span={12}>
          <Form.Item
            name={[name, 'phone']}
            label="Teléfono Móvil"
            rules={[
              {
                required: true,
                message: 'Dato requerido',
                len: 9,
              },
            ]}
            normalize={form.normalizers.numeric}
          >
            <Input type="text" maxLength={9} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name={[name, 'phoneAlt']}
            label="Teléfono Fijo (Opcional)"
            rules={[
              {
                message: 'Dato requerido',
                len: 9,
              },
            ]}
            normalize={form.normalizers.numeric}
          >
            <Input type="text" maxLength={9} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <p>Escritura donde consta el poder o mandato (si corresponde)</p>
          <p>Archivos JPG, PNG o PDF - Tamaño máximo 5MB.</p>
        </Col>
        <AloneCol lg={12} xs={24}>
          <Form.Item
            name={[name, 'documents']}
            rules={[{ required: true, message: 'Documento obligatorio' }]}
          >
            <FileSelect accept={'image/*,.pdf'} maxSizeKb={10240} maxFileCount={3} enableFileList>
              Cargar Documento
            </FileSelect>
          </Form.Item>
        </AloneCol>
      </Row>
    </>
  );
};

MandataryForm.propTypes = {
  field: PropTypes.shape().isRequired,
  onFinish: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default MandataryForm;
